import React, { useState } from "react";
import "./HomeComp1.css";
import CountUp from "react-countup";
import { addToCart } from "../../redux/slices/cartSlice";
import { useDispatch } from "react-redux";
const HomeComp2 = ({user}) => {

  const dispatch = useDispatch();
    const coffeeItems = [
        { id: 1, name: "robusta", image: "images/seracoffee-2.jpeg", price: "50.90" ,description:"Robusta coffee powder is known for its intense, full-bodied flavor with a rich, earthy taste and a hint of bitterness."},
        { id: 2, name: "roasted", image: "images/seracoffee-4.jpeg", price: "50.90" ,description:"Roasted coffee powder is made from carefully roasted coffee beans, bringing out deep, complex flavors and a rich aroma."},
        { id: 3, name: "arabica", image: "images/seracoffee-5.jpeg", price: "50.90" ,description:"Arabica coffee powder is known for its mild, smooth taste with subtle sweetness and balanced acidity."},
        { id: 4, name: "Chukku kappi", image: "images/seracoffee-1.jpeg", price: "50.90" ,description:"Chukku Kappi is a traditional South Indian herbal coffee made with dry ginger (chukku), black pepper, and aromatic spices."},
      ];
    const handleAddToCart = (product) => {
       dispatch(addToCart({ item: product, isGuest: !user }));
     };
  return (
    <>
    <section className="ftco-section bg-imagea">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 pr-md-5">
            <div className="heading-section text-md-right text-white " data-aos="fade-up">
              <span className="subheading">Discover</span>
              <h2 className="mb-4 text-white z-1">Our Products</h2>
              <p className="mb-4 text-white">
                We pride ourselves on aromatic, real coffee that everyone loves and wants to drink. Our coffee is produced in the best way without adding any chemicals. 
                   We use modern roasters, grinders and packing machines 
              </p>
              <p>
                <a href="/shop" className="btn btn-primary btn-outline-primary px-4 py-3 rounded-0">
                  Shop Now
                </a>
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row" >
              {["seracoffee-7.jpeg", "seracoffee-3.jpeg", "seracoffee-3.jpeg", "seracoffee-7.jpeg"].map((img, index) => (
                <div className={`col-md-6 ${index % 2 !== 0 ? "mt-lg-4" : ""}`} key={index}>
                  <div className="menu-entry">
                  {/* <img src="images/seracoffee-1.jpeg" width={200} height={200} className="img-fluid" /> */}
                    <a href="#" className="img" style={{ backgroundImage: `url(images/${img})`, width:'250px', height:'250px'}}></a>
                    {/* <img src={`images/${img}`} alt={`Sera Coffee ${index + 1}`} className="img-fluid" style={{ width: '200px', height: '250px', objectFit: 'cover' }} /> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="ftco-counter ftco-bg-dark img" id="section-counter" style={{ backgroundImage: "url(images/bg_2.jpg)" }} data-stellar-background-ratio="0.5">
      <div className="overlay img-fluid"></div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="row">
              {[
                { number: 100, text: "Coffee Branches" },
                { number: 85, text: "Number of Awards" },
                { number: 10567, text: "Happy Customer" },
                { number: 900, text: "Staff" },
              ].map((item, index) => (
                <CounterItem key={index} number={item.number} text={item.text} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="ftco-section bg-imagea">
      <div className="container">
        <div className="row justify-content-center mb-5 pb-3" data-aos="fade-up">
          <div className="col-md-7 heading-section text-center">
            <span className="subheading">Discover</span>
            <h2 className="mb-4 text-white">Best Coffee Sellers</h2>
            <p className="p-color">
            Our coffee is capable of everything that reminds you of a nostalgic feel.   Coffee powder produced from the best quality coffee beans will change your life.  Happiness will be with you  
            </p>
          </div>
        </div>
        <div className="row">
          {coffeeItems.map((item) => (
            <div className="col-md-3" key={item.id}>
              <div className="menu-entry">
              <img src={item.image} alt={item.name}  className="img-fluid" />
                {/* <a href={`/product/${item.id}`} className="img" style={{ backgroundImage: `url(${item.image})` }}></a> */}
                <div className="text text-center pt-4">
                  <h3>
                    <a href="#" className="text-decoration-none">{item.name}</a>
                  </h3>
                  <p className="p-color">{item.description}</p>
                  <p className="price">
                    <span>{item.price}</span>
                  </p>
                  <p>
                    <a href="/shop" className="btn btn-primary btn-outline-primary rounded-0">
                      Shop Now
                    </a>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

   <section className="ftco-gallery bg-imagea container-fluid">
  <div className="container-wrap">
    <div className="row no-gutters" data-aos="fade-up">
      <div className="col-md-3 ">
        <a href="/shop" className="gallery img d-flex align-items-center" style={{backgroundImage: 'url(images/coffeeBg.jpg)'}}>
          <div className="icon mb-4 d-flex align-items-center justify-content-center">
            <span className="icon-search" />
          </div>
        </a>
      </div>
      <div className="col-md-3">
        <a href="/shop" className="gallery img d-flex align-items-center" style={{backgroundImage: 'url(images/coffeeBg2.jpg)'}}>
          <div className="icon mb-4 d-flex align-items-center justify-content-center">
            <span className="icon-search" />
          </div>
        </a>
      </div>
      <div className="col-md-3">
        <a href="/shop" className="gallery img d-flex align-items-center" style={{backgroundImage: 'url(images/coffeeImage1.jpg)'}}>
          <div className="icon mb-4 d-flex align-items-center justify-content-center">
            <span className="icon-search" />
          </div>
        </a>
      </div>
      <div className="col-md-3 ">
        <a href="/shop" className="gallery img d-flex align-items-center" style={{backgroundImage: 'url(images/coffeeBg9.jpg)'}}>
          <div className="icon mb-4 d-flex align-items-center justify-content-center">
            <span className="icon-search" />
          </div>
        </a>
      </div>
    </div>
  </div>
   </section> 
    </>
  );
};



const CounterItem = ({ number, text }) => {
    return (
      <div className="col-md-6 col-lg-3 d-flex justify-content-center counter-wrap ">
        <div className="block-18 text-center">
          <div className="text">
            <div className="icon">
              <span className="flaticon-coffee-cup"></span>
            </div>
            <strong className="number counterNum" data-number={number}><CountUp className="counterNum" end={number} duration={5}/></strong>
            <p className="text-white">{text}</p>
          </div>
        </div>
      </div>
    );
  };


export default HomeComp2;
